import orders from './list/reducers'
import searchAddressWithNo from './searchAddressWithNo/reducers'
import create from './create/reducers'
import activeOrders from './activeOrders/reducers'

export default {
  orders,
  searchAddressWithNo,
  create,
  activeOrders,
}
